export class DataProvider {
	constructor() {
		this.data = {};
	}

	set(name, data) {
		this.data[name] = data;
	}

	get(name) {
		return this.data[name];
	}

	setRaw(name, data) {
		this.set("raw." + name, data);
	}

	getRaw(name) {
		return this.get("raw." + name);
	}
}